import styled from 'styled-components';

const MyDiv = styled.div`
  .main {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    background-color: #f9f9f9;
    border-radius: 12px;
  }
 .col{
    color:rgba(0, 0, 0, 1)
}

// .btn{

// &:hover {
//   background-color: #006838;
//   color: #FFFFFF;
  
// }
`;

export default MyDiv;
